import React from 'react';

import DataProvider from '@context/DataContext';
import Pagination from '@molecules/Pagination/Pagination';
import SearchTabs from '@molecules/SearchTabs/SearchTabs';
import SearchResults from '@organisms/SearchResults/SearchResults';
import SearchForm from '@templates/SearchForm/SearchForm';
import ResultsSummary from '@atoms/ResultsSummary/ResultsSummary';

const SearchContents = ({ pagination, searchConfig, suggestConfig, searchForm, contentHeadings, localStorageKey, moduleType }) => {
  const sConfig = { ...searchForm, suggestConfig: suggestConfig, contentHeadings: contentHeadings };

  return (
    <DataProvider
      config={searchConfig}
      maxPages={pagination?.maxPages}
      suggestConfig={suggestConfig}
      localStorageKey={localStorageKey}
      moduleType={moduleType}
      contentHeadings={contentHeadings}
    >
      <div className="base-search-banner__wrapper">
        <div className="container">
          <SearchForm {...sConfig} />
        </div>
        <div className="container container--secondary">
          <ResultsSummary />
          <SearchTabs />
          <SearchResults collection={searchConfig.collection} />
          <Pagination {...pagination} />
        </div>
      </div>
    </DataProvider>
  );
};
export default SearchContents;
